import { ButtonLink } from '@shared/components/ui/button-link/ButtonLink';

export default function SidebarWidget() {
    return (
        <div className="mx-auto w-full max-w-60 rounded-2xl bg-mp-background px-4 py-5 text-center">
            <h3 className="mb-2 font-semibold text-mp-foreground">#1 Service Plan Dashboard</h3>
            <p className="mb-4 text-mp-muted text-theme-sm">The Intelligent Solution for Automotive Retention.</p>
            <ButtonLink to="/service-plans/new" size="sm" className="w-full font-medium">
                Create New
            </ButtonLink>
        </div>
    );
}
